module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    attrs: {
      "id": "contactDebtorList"
    }
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": this.servicesTexts[this.$engine.user.currentService.id].title
    }
  }), _vm._v(" "), _c('f7-searchbar', {
    staticClass: "search",
    attrs: {
      "cancel-link": "Cancel",
      "search-list": "#contact-debtors-list",
      "placeholder": _vm.servicesTexts[this.$engine.user.currentService.id].search_in
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    attrs: {
      "id": "contact-debtors-list",
      "contacts": ""
    }
  }, _vm._l((this.contactSelectionList), function(group, key) {
    return _c('f7-list-group', {
      key: key
    }, [_c('f7-list-item', {
      attrs: {
        "title": key,
        "group-title": ""
      }
    }), _vm._v(" "), _vm._l((group), function(contact) {
      return _c('li', {
        on: {
          "change": function($event) {
            return _vm.changeItem()
          }
        }
      }, [_c('label', {
        staticClass: "item-radio item-content boxRequest"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.contactDebtors),
          expression: "contactDebtors"
        }],
        staticClass: "inputContact",
        attrs: {
          "type": "radio",
          "name": "contactDebtorCheckbox"
        },
        domProps: {
          "value": contact.id,
          "checked": _vm._q(_vm.contactDebtors, contact.id)
        },
        on: {
          "change": function($event) {
            _vm.contactDebtors = contact.id
          }
        }
      }), _vm._v(" "), _c('i', {
        staticClass: "icon icon-radio"
      }), _vm._v(" "), _c('div', {
        staticClass: "item-inner"
      }, [_c('div', {
        staticClass: "item-title"
      }, [_vm._v(_vm._s(contact.label))])])])])
    })], 2)
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: _vm.colorBottomButton
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('f7-button', {
    staticClass: "orangeConfirmationButton button-inner-color",
    attrs: {
      "round": "",
      "title": "cancel"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('f7-link', [_vm._v(" Cancel")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 offset-md-3"
  }, [_c('f7-button', {
    staticClass: "orangeConfirmationButton button-inner-color",
    attrs: {
      "round": "",
      "title": "Add"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('f7-link', [_vm._v(" " + _vm._s(_vm.servicesTexts[this.$engine.user.currentService.id].add))])], 1)], 1)])], 1), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "toolbarPageBottomBlank"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f03cf648", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f03cf648","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/ContactDebtorList.vue
// module id = 1732
// module chunks = 2